import React, { useCallback, useEffect, useState } from 'react';
import { Col, Layout, PageHeader, Row, Tabs } from 'antd';
import { useHistory, useParams } from 'react-router';
import { Role } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { RoleDetailsForm } from './role-details-form';
import { RolePermissionsForm } from './role-permissions-form';
import { RoleUsersForm } from './role-users-form';

export function RolePage() {
  const history = useHistory();
  const { id } = useParams() as any;
  const [role, setRole] = useState<Role>();

  const { Content } = Layout;

  const onBackClick = () => {
    history.goBack();
  };

  const loadRole = useCallback(() => {
    apiClient
      .get(`roles/${id}`)
      .then((response: any) => {
        setRole(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [id]);

  const onRoleChanged = () => {
    loadRole();
  };

  useEffect(() => {
    if (!id) {
      return;
    }
    loadRole();
  }, [id, loadRole]);

  const TabContent = (props: any) => {
    return (
      <Content style={{ backgroundColor: '#fff' }}>
        <Row>
          <Col span={8} xs={24} sm={24} md={12} lg={10} xl={10} xxl={8}>
            {props.children}
          </Col>
        </Row>
      </Content>
    );
  };

  return (
    <>
      <PageHeader title="Rol düzenle" subTitle={role?.name} onBack={onBackClick} />
      <Content>
        <Tabs>
          <Tabs.TabPane tab="Detaylar" key="details">
            <TabContent>
              <RoleDetailsForm role={role} onSaved={onRoleChanged} />
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Yetkiler" key="permissions">
            <TabContent>
              <RolePermissionsForm role={role} />
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Kullanıcılar" key="users">
            <TabContent>
              <RoleUsersForm role={role} />
            </TabContent>
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </>
  );
}
